/**
 * persistenceSchema.js — Constants for the runtime snapshot schema.
 */

/** Bump this string when the snapshot shape changes incompatibly. */
export const SCHEMA_VERSION = "kv_snapshot_v1";

/** sessionStorage key for the runtime snapshot. */
export const SNAPSHOT_KEY   = "kv_runtime_snapshot";

/** Snapshots older than 4 hours are discarded on restore. */
export const TTL_MS         = 4 * 60 * 60 * 1000;

/** Max serialized snapshot size (12 KB). Prevents unbounded storage growth. */
export const MAX_SIZE_BYTES = 12_288;
